import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'va-action-menu',
  template: `
    <button type="button" mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon [style.color]="color">{{ icon }}</mat-icon>
    </button>
    <mat-menu #menu="matMenu" x-position="before" y-position="below">
      <button type="button" mat-menu-item *ngFor="let action of actions" (click)="actionSelected.emit(action)">
        {{ action }}
      </button>
    </mat-menu>
  `,
})
export class VaActionMenuComponent {
  @Input() icon = 'more_vert';
  @Input() color = 'rgba(0,0,0,0.87)';
  @Input() actions: string[];
  @Output() actionSelected = new EventEmitter<string>();
}
